<script setup lang="ts">
import { computed } from 'vue'
import { useSidebar } from '@/composables/useSidebar'
import {
  Sidebar,
  SidebarInset,
  SidebarGroup,
  SidebarGroupLabel,
  SidebarMenu,
} from '@/components/ui/sidebar'
import SidebarHeader from './sidebar/SidebarHeader.vue'
import SidebarNavGroup from './sidebar/SidebarNavGroup.vue'
import { navSections } from './sidebar/data'

const { open, isHovered, isMobile } = useSidebar()

// Content shows when the sidebar is expanded, hovered (collapsed rail), or on mobile.
const showContent = computed(() => open.value || isHovered.value || isMobile.value)
</script>

<template>
  <Sidebar side="left" collapsible="icon">
    <SidebarHeader :show-content="showContent" />

    <SidebarContent class="overflow-y-auto px-5 duration-300 ease-linear">
      <nav class="mb-6">
        <div class="flex flex-col gap-4">
          <SidebarNavGroup
            v-for="section in navSections"
            :key="section.label"
            :label="section.label"
            :items="section.items"
            :show-content="showContent"
          />
        </div>
      </nav>
    </SidebarContent>
  </Sidebar>
</template>
